const E = "Search Result Section", _ = "Search Submitted", S = "Free Text Search", T = "Search Bar Engaged", A = "Focus", R = "Typed", e = "Suggested Search", c = "Search Result Clicked", t = "HELP_CENTER";
export {
  S as FREE_TEXT_SEARCH_QUERY_SUBMITTED_LABEL,
  t as HELP_CENTER,
  _ as QUERY_SUBMITTED_EVENT_NAME,
  A as SEARCH_BAR_ENGAGED_EVENT_FOCUS_LABEL,
  T as SEARCH_BAR_ENGAGED_EVENT_NAME,
  R as SEARCH_BAR_ENGAGED_EVENT_TYPED_LABEL,
  c as SEARCH_RESULT_CLICKED,
  E as SEARCH_RESULT_SECTION_EVENT_NAME,
  e as SUGGESTED_SEARCH_QUERY_SUBMITTED_LABEL
};
//# sourceMappingURL=help-center-articles-search22.js.map
